<template>
  <b-tab title="Equipes" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DA EQUIPES :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterEquipes(filtro)" :fields="fields.equipe">
        <template #cell(data)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.data).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(custo)="data">
          <div>
            <p>{{ formatter.format(data.item.custo) }}</p>
          </div>
        </template>
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="diarios(data.item)" v-b-tooltip.hover title="Diário">
              <b-icon icon="journal-medical" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="despesas(data.item)" v-b-tooltip.hover title="Despesas">
              <b-icon icon="calculator" variant="warning"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="relatorio(data.item)" v-b-tooltip.hover title="Relatório">
              <b-icon icon="file-earmark-post-fill" variant="info"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="deletar(data.item)" v-b-tooltip.hover title="Deletar">
              <b-icon icon="trash-fill" variant="danger"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="eqp-desc-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Descrição"
              v-model="filtro.descricao"
            />
            <b-form-input
              id="eqp-lider-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Lider"
              v-model="filtro.lider"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <equipe-modal ref="editorEquipe" />
      <diario-list-modal ref="diarioListModal" />
      <despesa-list-modal ref="despesaListModal" />
      <relatorio-equipe-modal ref="relatorioEquipeModal" />
      <confirm-modal ref="confirmDelEquipe" :descricao="'Deseja realmente remover a equipe ?'" @executar="executar()" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipeStore } from "@/stores/EquipeStore";
import Equipe from "@/models/Equipe";
import TableFields from "@/tools/TableFields";
import EquipeModal from "@/components/modals/equipe/EquipeModal";
import DiarioListModal from "@/components/modals/equipe/DiarioListModal";
import DespesaListModal from "@/components/modals/equipe/DespesaListModal";
import RelatorioEquipePrintModal from "@/components/modals/equipe/RelatorioEquipePrintModal";
import ConfirmModal from "@/components/modals/diversos/ConfirmModal.vue";
import Notificacao from "@/models/Notificacao";

export default {
  name: "EquipeTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: { descricao: "", lider: "" },
      equipe: new Equipe(0, "", "Nova Equipe", new Date(), 0.0),
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
    };
  },

  components: {
    "equipe-modal": EquipeModal,
    "confirm-modal": ConfirmModal,
    "diario-list-modal": DiarioListModal,
    "despesa-list-modal": DespesaListModal,
    "relatorio-equipe-modal": RelatorioEquipePrintModal,
  },

  methods: {
    adicionar() {
      this.equipe = new Equipe(0, "", "Nova Equipe", new Date(), 0.0);
      this.$refs.editorEquipe.call(this.equipe);
    },

    editar(equipe) {
      this.$refs.editorEquipe.call(equipe);
    },

    diarios(equipe) {
      this.$refs.diarioListModal.call(equipe);
    },

    despesas(equipe) {
      this.$refs.despesaListModal.call(equipe);
    },

    relatorio(equipe) {
      this.$refs.relatorioEquipeModal.call(equipe);
    },

    deletar(equipe) {
      this.equipe.update(equipe);
      this.$refs.confirmDelEquipe.call();
    },

    executar() {
      this.equipeStore.LISTAR_EQUIPES(this.equipe.id).then(() => {
        if (this.getDiarios.length === 0 && this.getDespesas.length === 0) {
          this.equipeStore.REMOVER_EQUIPE(this.equipe.id);
        } else {
          this.store.NOTIFICAR(new Notificacao("Existem relatórios diários e despesas na equipe!", "Não Executado!", "danger"));
        }
      });
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipeStore = useEquipeStore();
    const { getFilterEquipes } = storeToRefs(equipeStore);
    const { getDiarios } = storeToRefs(equipeStore);
    const { getDespesas } = storeToRefs(equipeStore);

    return {
      store,
      equipeStore,
      getFilterEquipes,
      getDiarios,
      getDespesas,
    };
  },
};
</script>

<style lang="scss" scoped>
#eqp-desc-filter {
  width: 18rem;
}
#eqp-lider-filter {
  width: 14rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
